import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import './footer.scss';

/**
 * Composant pour le footer des pages
 *
 * @constructor
 */
export default function Footer() {
    return (
        <Box component="footer" className="container-footer">
            <Box className="footer-shell">
                <p className="footer-copy">© Copyright {new Date().getFullYear()} SDDEA. Tous droits réservés</p>

                <nav className="footer-nav" aria-label="Liens de pied de page">
                    <Link className="footer-link" to="/mentions-legales">
                        Mentions légales
                    </Link>
                    <Link className="footer-link" to="/politique-confidentialite">
                        Politique de Confidentialité
                    </Link>
                </nav>
            </Box>
        </Box>
    );
}
